module.exports = __webpack_public_path__ + "static/media/DSC_0017.4005d5ae.jpg";